import React, { useState, useEffect, useCallback } from "react";
import "../../assets/styles/local/AddDocumentsWithPagination.css";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import lockGrey from "../../assets/icons/lockGrey.svg";
import lockBlue from "../../assets/icons/lockBlue.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  ADD_ASSETS_EQUIPMENT,
  API_URL,
  UPDATE_ASSETS,
} from "../../redux/constants/type";
import roundFileSize from "../../utils/Documents/roundFileSize";
import moment from "moment";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import {
  AddDocumentToAsset,
  DeleteAssetsDocument,
  EmptyProductPart,
  UpdateIslocked,
} from "../../redux/actions/action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DeletePopUp from "../Dailogs/DeletePopUp";
import DocumentUploaderWithProgress from "../Common/Document_Uploader_With_Progress";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { EyeOutlined } from "@ant-design/icons";
import { getFilePreview } from "../../utils/filePreview/filePreview";
import FilePreviewModal from "../../utils/filePreview/FilePreviewModal";

const AssetsDocumentsTab = ({ assetsData, type, setUpdatedDoc }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userId = window.localStorage.getItem("userid");
  const roleId = window.localStorage.getItem("roleid");
  const userFirstName = window.localStorage.getItem("firstname");
  const userLastName = window.localStorage.getItem("lastname");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [filePreview, setFilePreview] = useState(null);

  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [newDoc, setNewDoc] = useState([]);

  const assetsListNewData = useSelector((state) => state.user.assetsListNew);
  const assetUpdateRes = useSelector((state) => state.user.assetUpdateRes);

  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  useEffect(() => {
    if (type === "Update" && assetsData.assetdocs) {
      // if (assetsData.assetdocs.length > 0) {
      //   let supplierObj = assetsData.assetdocs;
      //   var i;
      //   for (i = 0; i < supplierObj.length; i++) {
      //     supplierObj[i].documentname = supplierObj[i]["documentname"];
      //     supplierObj[i].documentextension =
      //       supplierObj[i]["documentextension"];
      //     supplierObj[i].documentcontent = supplierObj[i]["documentcontent"];
      //     supplierObj[i].link = supplierObj[i]["link"];
      //     supplierObj[i].documentsize = supplierObj[i]["documentsize"];
      //     supplierObj[i].islocked = supplierObj[i]["islocked"];
      //     supplierObj[i].uploadedbyfirstname = userFirstName;
      //     supplierObj[i].uploadedbylastname = userLastName;
      //     supplierObj[i].userId = userId;
      //   }
      //   setNewDoc(supplierObj);
      // }

      setNewDoc(assetsData.assetdocs);
    }
  }, [assetsData, type]);

  const calculatePagination = useCallback(
    (pageNumber) => {
      const records = newDoc || [];
      const startRecordIndex = Math.max(10 * pageNumber - 9, 1);
      const endRecordIndex = Math.min(10 * pageNumber, records.length);
      const tempPaginationObj = {
        totalRecords: records.length,
        currentPage: pageNumber,
        startRecordIndex,
        endRecordIndex,
        totalPages: Math.ceil(records.length / 10),
        records: records.slice(startRecordIndex - 1, endRecordIndex),
      };
      setPaginationObj({ ...tempPaginationObj });
      setUpdatedDoc(newDoc);
    },
    [newDoc],
  );

  useEffect(() => {
    calculatePagination(1);
  }, [calculatePagination, newDoc]);

  const onFileUploaded = (data) => {
    const newDocument = {
      documentname: data[0].name,
      documentextension: data[0].type,
      documentcontent: "string",
      link: data[0].link,
      documentsize: data[0].size,
      islocked: 0,
      uploadedbyfirstname: userFirstName,
      uploadedbylastname: userLastName,
      documentId: userId,
    };

    setNewDoc((prevFileList) => [...prevFileList, newDocument]);
  };

  const fileValidationBeforeUpload = (file) => {
    let isValid = true;
    // Check if the document with the same name already exists
    if (newDoc.some((doc) => doc.documentname === file.name)) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "Document with the same name already exists.",
        },
        false,
      );
      isValid = false;
    }
    return isValid;
  };

  const handleDeleteDocumentFun = () => {
    const updatedFileList = newDoc.filter(
      (item) => item.documentname !== deleteRowData.documentname,
    );
    setNewDoc(updatedFileList);
    const payload = {
      documentid: deleteRowData.documentId,
    };
    dispatch(DeleteAssetsDocument(payload));
    setDeleteDocument(false);
    setDeleteRowData(null);
  };

  const lockDocument = (item) => {
    const updatedFileList = newDoc.map((file) =>
      file.documentId === item.documentId
        ? { ...file, islocked: file.islocked ? 0 : 1 }
        : file,
    );
    setNewDoc(updatedFileList);
    const payload = {
      documentid: item.documentId,
      islocked: item.islocked ? 0 : 1,
    };
    dispatch(UpdateIslocked(payload));
  };

  useEffect(() => {
    if (
      (assetsListNewData?.status === true &&
        assetsListNewData?.data &&
        newDoc?.length) ||
      (assetUpdateRes?.status === true &&
        assetUpdateRes?.data &&
        newDoc?.length)
    ) {
      const payload = {
        assetid: assetsListNewData?.data,
        assetdocs: newDoc.filter((data) => data?.link),
      };
      dispatch(AddDocumentToAsset(payload));
      history.push("/asset-management");
      // dispatch({
      //   type: UPDATE_ASSETS,
      //   data: {},
      // });
      dispatch({
        type: ADD_ASSETS_EQUIPMENT,
        data: {},
      });
    }
  }, [
    assetsListNewData?.data,
    assetsListNewData?.status,
    assetUpdateRes?.data,
    assetUpdateRes?.status,
  ]);

  useEffect(() => {
    if (assetsListNewData?.status === true || assetUpdateRes?.status === true) {
      if (!newDoc.length > 0) {
        // history.push("/asset-management");
        dispatch(EmptyProductPart());
        dispatch({
          type: UPDATE_ASSETS,
          data: {},
        });
        dispatch({
          type: ADD_ASSETS_EQUIPMENT,
          data: {},
        });
      }
    }
  }, [assetsListNewData, assetUpdateRes]);

  const pdfdownload = (event, documentid, documentname, linkParam) => {
    if (documentid) {
      axios({
        method: "post",
        url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
        // data: {
        //   message?.message
        // },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // var el = document.createElement('div');
        const document = window.document || {};
        const link = document.createElement("a");
        link.href = url;
        link.download = documentname;
        document.body.appendChild(link);
        link.click();
        // link.setAttribute("download", `FinalDocument.pdf`);

        // Append to html link element page
        // document.body.appendChild(link);

        // Start download
        // link.click();

        // Clean up and remove the link
        // link.parentNode.removeChild(link);
        // return docFileDownload;
        // }, 1000)
      });
    } else {
      const url = window.URL.createObjectURL(new Blob([linkParam]));
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
    }
  };

  const renderDocumentRows = () => {
    return paginationObj?.records?.map((item) => (
      <tbody
        key={item.documentId}
        style={{ borderBottom: "0.5px dashed #A5A5A5" }}
      >
        <tr className="products-and-parts-actionGap">
          <td className="d-flex gap-3">
            <img
              className={"products-and-parts-dltIcon"}
              style={{
                cursor:
                  item.documentId === userId ||
                  item.islockedby === userId ||
                  roleId === process.env.REACT_APP_IS_OWNER
                    ? item.islocked
                      ? "not-allowed"
                      : "pointer"
                    : "not-allowed",
                opacity: item.islocked ? "0.5" : "1",
              }}
              src={DeleteIcon}
              alt=""
              onClick={() => {
                if (
                  !item.islocked &&
                  (item.documentId === userId ||
                    item.islockedby === userId ||
                    roleId === process.env.REACT_APP_IS_OWNER)
                ) {
                  setDeleteRowData(item);
                  setDeleteDocument(true);
                }
              }}
            />
            <img
              style={{
                cursor:
                  item.documentId === userId ||
                  item.islockedby === userId ||
                  roleId === process.env.REACT_APP_IS_OWNER
                    ? "pointer "
                    : "not-allowed",
                display: item.documentId === userId && "none",
              }}
              className="products-and-parts-dltIcon"
              src={item.islocked ? lockBlue : lockGrey}
              alt=""
              onClick={() => {
                if (
                  item.documentId === userId ||
                  item.islockedby === userId ||
                  roleId === process.env.REACT_APP_IS_OWNER
                ) {
                  lockDocument(item);
                }
              }}
            />
            {console.log("asc2", item.documentId === userId)}
            {/* {console.log("asc23", assetsData)} */}
          </td>

          <td
            onClick={(event) =>
              pdfdownload(
                event,
                item?.documentId,
                item.documentname,
                item?.link,
              )
            }
            className="products-and-parts-documntName"
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            {item.documentname}
          </td>

          <td className="products-and-parts-documntName">
            {roundFileSize(item.documentsize)}
          </td>

          <td className="products-and-parts-documntName">
            {moment(item.documentDate).format("DD.MM.YYYY")}
          </td>

          <td className="ps-3">
            {item.uploadedbyfirstname + " " + item.uploadedbylastname}
          </td>

          <td className="pointer">
            <EyeOutlined
              onClick={() => {
                setFilePreview(
                  getFilePreview({
                    // file: file, // local upload file
                    url: item.link,
                    type: item.link.split(".").pop(),
                    name: item.documentname,
                  }),
                );
              }}
            />
          </td>
        </tr>
      </tbody>
    ));
  };

  return (
    <>
      <div
        className="products-and-parts-content pe-4 ps-3"
        style={{ overflowX: "auto" }}
      >
        <div className="products-and-parts-doc-tab-container">
          <div className="container-fluid ps-5 products-and-parts-add-doc-with-pagination-container">
            <DocumentUploaderWithProgress
              maxSizeInMb={100}
              onUploaded={onFileUploaded}
              multiple={true}
              beforeFileUpload={fileValidationBeforeUpload}
            >
              <div className="d-flex gap-2 pointer ps-2">
                <img
                  src={CardAddButton}
                  className="products-and-parts-addDocImg"
                  alt=""
                />
                <p className="pt-1 products-and-parts-addDocText">
                  {/* Add Document */}
                  {t("Add Document")}
                </p>
              </div>
            </DocumentUploaderWithProgress>

            <div className="products-and-parts-custom-pagination">
              <div className="range-text">
                {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex} of ${paginationObj.totalRecords}`}
              </div>
              <div className="products-and-parts-pagination-buttons">
                <div
                  className={`products-and-parts-pagination-button ${
                    paginationObj.currentPage === 1 ? "disabled" : ""
                  }`}
                  onClick={() =>
                    calculatePagination(paginationObj.currentPage - 1)
                  }
                >
                  <BsChevronLeft />
                </div>
                <div className="pagination-current-page">
                  {paginationObj.currentPage}
                </div>
                <div
                  className={`products-and-parts-pagination-button ${
                    paginationObj.totalPages === 0 ||
                    paginationObj.totalPages === paginationObj.currentPage
                      ? "disabled"
                      : ""
                  }`}
                  onClick={() =>
                    calculatePagination(paginationObj.currentPage + 1)
                  }
                >
                  <BsChevronRight />
                </div>
              </div>
            </div>
          </div>
          <table className="table table-borderless">
            <thead>
              <tr
                className="products-and-parts-textHeadings"
                style={{ borderBottom: "1px solid #A5A5A5" }}
              >
                <th scope="col products-and-parts-actionGap">
                  {/* Actions */}
                  {t("Actions")}
                </th>
                <th scope="col products-and-parts-documentGap">
                  {/* Document Name */}
                  {t("Document Name")}
                </th>
                <th scope="col">
                  {/* Size */}
                  {t("Size")}
                </th>
                <th scope="col">
                  {/* Date */}
                  {t("Date")}
                </th>
                <th scope="col">
                  {/* Created by */}
                  {t("Created by")}
                </th>
                <th></th>
              </tr>
            </thead>
            {renderDocumentRows()}
          </table>
          <FilePreviewModal
            open={filePreview}
            file={filePreview}
            onClose={() => setFilePreview(null)}
          />
          ;
          {deleteDocument && (
            <DeletePopUp
              animation={true}
              handleDelete={handleDeleteDocumentFun}
              show={deleteDocument}
              onHide={() => setDeleteDocument(false)}
              title1={"This data will be removed from the system"}
              title2={"and cannot be undone."}
              title3={"Do you want to proceed?"}
              no={"No"}
              yes={"Yes"}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AssetsDocumentsTab;
